/** Facebook Post — document knowledge definition. Pure data. */
export default {
  id: 'facebook-post',
  name: 'Facebook Post',
  description: 'A feed image for announcements, promotions, and link sharing on Facebook.',
  purpose: 'Social Engagement & Reach',
  recommendedSizes: [
    { name: 'Landscape', width: 1200, height: 630, unit: 'px' },
    { name: 'Square', width: 1080, height: 1080, unit: 'px' },
  ],
  supportedOrientations: ['landscape', 'square'],
  supportsMultiplePages: false,
  supportsBleed: false,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: false,
  supportsTables: false,
  supportsPricing: true,
  supportsCTA: true,
  supportsOffers: true,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Visual', 'Headline', 'Body Text', 'CTA'],
};
